import MDBox from "components/MDBox";

export default function PageContainer({ children }) {
  return <MDBox sx={{ minHeight: "calc(100vh - 146px)" }}>{children} </MDBox>;
}
